import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as serviceItemSlice from './serviceItemSlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../../Auth';
import { getAllServiceItems } from './serviceItemAPI';


export function* onLoadServiceItemsStartAsync(){

    try{
        
        yield put(serviceItemSlice.actions.startCall({ callType: serviceItemSlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllServiceItems, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let serviceItems = response.data;
            
            yield put(serviceItemSlice.actions.serviceItemsFetched({ totalCount, serviceItems }));
        }
    }
    catch(error){

        console.log(error);


        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
            let errorMsg = "There was an error retrieving service item information.";
            
            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));

            }

            // yield put(uiSlice.actions.showNotification({
            //     status:"error",
            //     title:"Error",
            //     message: errorMsg
            // }));

            yield put(serviceItemSlice.actions.catchError({
                callType: serviceItemSlice.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export const actionTypes = {
    FetchServiceItems: "[FetchServices] Fetch Service Items API Action"
  };

export const actions = {

    fetchServiceItems: () => ({ type: actionTypes.FetchServiceItems, payload: { undefined } })
  
};

export function* fetchServiceItems(){

    yield takeEvery(actionTypes.FetchServiceItems, onLoadServiceItemsStartAsync);    
};


const fSagas = [fork(fetchServiceItems)];

export function* saga(){
    yield all ([...fSagas]);
};
